<template>
  <div class="wg-reservations">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-md-6 align-items-center" style="padding: 60px;">
          <div class="content">
            <div class="heading-section text-center">
              <div class="sub">{{ $t("franchise") }}</div>
              <div class="main" :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ franchise.home_title }}</div>
              <div class="text">{{ franchise.home_description }}</div>
              <div class="divider"><div></div></div>
            </div>

            <form class="book-form">
              <fieldset class="username">
                <input
                  type="text"
                  @input="formError = ''"
                  placeholder="Username*"
                  v-model="username"
                  required
                />
              </fieldset>

              <div class="columns">
                <fieldset class="email">
                  <input
                    type="email"
                    @input="formError = ''"
                    placeholder="Email*"
                    v-model="email"
                    required
                  />
                </fieldset>
                <fieldset class="phone">
                  <input
                    type="text"
                    placeholder="Phone*"
                    v-model="phone"
                    @input="phone = phone.replace(/[^0-9+]/g, ''); formError = ''"
                    required
                  />
                </fieldset>
              </div>

              <div class="columns">
                <fieldset class="select event-number">
                  <select v-model="selectedCity" required @input="formError = ''">
                    <option value="">{{ $t("city") }}*</option>
                    <option v-for="city in cities" :key="city" :value="city">
                      {{ city }}
                    </option>
                  </select>
                </fieldset>
                <fieldset class="Region">
                  <input type="text" placeholder="Region" v-model="region" />
                </fieldset>
              </div>

              <fieldset class="message">
                <textarea
                  placeholder="Your Message*"
                  rows="2"
                  @input="formError = ''"
                  v-model="message"
                  required
                ></textarea>
              </fieldset>
              <div v-if="formError" class="error-message">
                {{ formError }}
              </div>
              <!-- Success -->
              <div v-if="formSuccess" style="color: #EFBED4; font-size: 20px;">
                {{ formSuccess }}
              </div>
              <div class="bot">
                <a
                  class="button-two-line w-full"
                  type="submit"
                  @click.prevent="submitFranchise"
                >
                  {{ $t("franchise") }}
                </a>
              </div>
            </form>
          </div>
        </div>

        <div class="col-md-6">
          <div class="image">
            <img :src="getImageUrl(franchise.home_image)" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "FranchiseComponent",
  data() {
    return {
      langStore,
      franchise: {},
      cities: [],

      // form fields
      username: "",
      email: "",
      phone: "",
      selectedCity: "",
      region: "",
      message: "",
      formError: "",
      formSuccess: "",
    };
  },
    watch: {
    "langStore.lang"() {
      this.fetchFranchise();
    },
  },


  async mounted() {
    this.fetchFranchise();
    this.fetchCities();
  },

  methods: {
    async fetchFranchise() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/home-franchise`,
          { params: { lang: this.langStore.lang } }
        );
        this.franchise = response.data;
      } catch (error) {
        console.error("Error fetching franchise data:", error);
      }
    },
    async fetchCities() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/cities`,
          { params: { lang: this.langStore.lang } }
        );
        this.cities = response.data;
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    },
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/${photo}`;
    },
    submitFranchise() {
      // Clear previous messages
      this.formError = "";
      this.formSuccess = "";

      if (
        !this.username ||
        !this.email ||
        !this.phone ||
        !this.selectedCity ||
        !this.message
      ) {
        this.formError = "Please fill all required fields.";
        return;
      }
      const payload = {
        username: this.username,
        email: this.email,
        phone: this.phone,
        city: this.selectedCity,
        region: this.region,
        message: this.message,
      };

      axios
        .post(`${process.env.VUE_APP_BASE_URL}/api/franchise`, payload)
        .then(() => {
          this.formSuccess = "Your request has been sent successfully!";

          // clear form fields
          this.username = "";
          this.email = "";
          this.phone = "";
          this.selectedCity = "";
          this.region = "";
          this.message = "";
        })
        .catch((err) => {
          console.error("Error sending franchise request:", err);
          this.formError = "Something went wrong. Please try again.";
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.error-message {
  color: #ff3b3b;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 900;
}

.success-message {
  color: #2ecc71;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 900;
}

.image {
  width: 100%;
  height: 100%; /* or a fixed height if needed */
  overflow: hidden;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* fills container, crops excess, no stretching */
  display: block;
}
</style>
